import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import HeaderOne from "../components/header/HeaderOne";
import Breadcrumb from "./Breadcrumb";
import { Link } from 'react-router-dom';
import TeamTwo from "../components/team/TeamTwo";
import FooterOne from "../components/footer/FooterOne";

import Accordion from 'react-bootstrap/Accordion';



function OurService() {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'About Us' }
    ];

    const schemaData = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "AboutPage",
                "@id": "https://www.aviteusbusiness.co.uk/about-us#page",
                "url": "https://www.aviteusbusiness.co.uk/about-us",
                "name": "About Aviteus | Chartered Accountants for UK SMEs",
                "description": "Aviteus supports SMEs and startups across the UK with accurate accounts, tax and payroll, fixed fees and clear advice.",
                "isPartOf": {"@id": "https://www.aviteusbusiness.co.uk/#website"},
                "primaryImageOfPage": "https://www.aviteusbusiness.co.uk/assets/team.jpg",
                "about": {"@id": "https://www.aviteusbusiness.co.uk/#business"},
                "inLanguage": "en-GB"
            },
            {
                "@type": "BreadcrumbList",
                "@id": "https://www.aviteusbusiness.co.uk/about-us#breadcrumbs",
                "itemListElement": [
                    {"@type":"ListItem","position":1,"name":"Home","item":"https://www.aviteusbusiness.co.uk/"},
                    {"@type":"ListItem","position":2,"name":"About","item":"https://www.aviteusbusiness.co.uk/about-us"}
                ]
            }
        ]
    };
    const [isVideoOpen, setIsVideoOpen] = useState(false);

    // Function to open the video overlay
    const openVideo = (e) => {
        e.preventDefault();
        setIsVideoOpen(true);
    };

    // Function to close the video overlay
    const closeVideo = (e) => {
        e.preventDefault();
        setIsVideoOpen(false);
    };

    // Effect to handle the escape key for closing the video overlay
    useEffect(() => {
        const handleKeyUp = (e) => {
            if (e.keyCode === 27) {
                setIsVideoOpen(false);
            }
        };

        // Add event listener for keyup
        document.addEventListener('keyup', handleKeyUp);

        // Cleanup function to remove event listener on component unmount
        return () => {
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    return (
        <div className=''>
            <Helmet>
                <title>About Aviteus | Chartered Accountants for UK SMEs</title>
                <meta name="description" content="Learn how Aviteus supports UK SMEs with accurate accounts, clear advice and fixed fees. ICAEW and ACCA certified. UK-wide service." />
                <link rel="canonical" href="https://www.aviteusbusiness.co.uk/about-us" />
                <script type="application/ld+json">
                    {JSON.stringify(schemaData)}
                </script>
            </Helmet>

            <HeaderOne />
            <Breadcrumb title="About Us" breadcrumbs={breadcrumbs} />
            {/* rts about us section start */}
            <div className="rts-about-area rts-section-gap">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6">
                            <div className="about-image-v-inner">
                                <div className="image-area">
                                    <img
                                        className="mt--110 img-1"
                                        src="assets/images/about/main/about-03.jpg"
                                        alt="Aviteus Business Solutions"
                                    />
                                    <img
                                        className="img-over"
                                        src="assets/images/about/main/about-04.jpg"
                                        alt="Professional Accounting Services"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-progress-inner">
                                <div className="title-area">
                                    <span>ABOUT AVITEUS BUSINESS SOLUTIONS</span>
                                    <h2 className="title">
                                        Focused on Clarity. Driven by Trust. Built for Growth.
                                    </h2>
                                </div>
                                {/* inner start */}
                                <div className="inner">
                                    <p className="disc">
                                        We started Aviteus to make accounting simple and useful for everyday decisions. Our roots in healthcare taught us the value of accuracy and care. Today, we serve SMEs and startups across the UK with the same standard. You get a steady team, clear timelines and reports you can act on.
                                    </p>
                                    <p className="disc">
                                        Our accountants hold ICAEW, ACCA and CIMA qualifications. We work across Xero, Sage and QuickBooks, and we support migrations and training. We learn your goals, tidy the data, set the right processes and keep you ahead of HMRC dates.
                                    </p>
                                    <Link to={'/contactus'} className="rts-btn btn-primary">
                                        Book a Free Consultation
                                    </Link>
                                </div>
                                {/* end */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* rts about us section end */}


            {/* Mission & Vision section start */}
            <div className="rts-service-area rts-section-gap bg-light">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-12">
                            <div className="text-center mb--40">
                                <p className="pre-title">Our Purpose</p>
                                <h2 className="title">What Guides Us</h2>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="service-one-inner-four h-100">
                                <div className="content text-center p-4">
                                    <h4 className="title mb-3">How We Work</h4>
                                    <p className="disc">
                                        We learn your goals, tidy the data, set the right processes and keep you ahead of HMRC dates. You get simple dashboards, monthly insights and proactive notes on risks and opportunities.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="service-one-inner-four h-100">
                                <div className="content text-center p-4">
                                    <h4 className="title mb-3">Team and Credentials</h4>
                                    <p className="disc">
                                        Our accountants hold ICAEW, ACCA and CIMA qualifications. We work across Xero, Sage and QuickBooks, and we support migrations and training.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-5 mt--30">
                        <div className="col-lg-12">
                            <div className="text-center mb--20">
                                <h3 className="title">Our Values</h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-one-inner-four text-center">
                                <div className="content p-3">
                                    <h5 className="title">Integrity</h5>
                                    <p className="disc">
                                        Honest advice and strict confidentiality.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-one-inner-four text-center">
                                <div className="content p-3">
                                    <h5 className="title">Accuracy</h5>
                                    <p className="disc">
                                        Precise books, compliant filings and clean audits.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-one-inner-four text-center">
                                <div className="content p-3">
                                    <h5 className="title">Commitment</h5>
                                    <p className="disc">
                                        We own deadlines and outcomes.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-one-inner-four text-center">
                                <div className="content p-3">
                                    <h5 className="title">Innovation</h5>
                                    <p className="disc">
                                        Secure cloud tools with real-time access.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-one-inner-four text-center">
                                <div className="content p-3">
                                    <h5 className="title">Partnership</h5>
                                    <p className="disc">
                                        We work with you as part of your team.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Mission & Vision section End */}

            {/* Team section - Hidden until client provides team details */}
            {/* <TeamTwo /> */}


            {/* rts faq section area */}
            <div className="rts-faq-section rts-section-gap rts-faq-bg bg_image">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="faq-two-inner">
                                <div className="title-area-faq">
                                    <span className="sub">FREQUENTLY ASKED QUESTIONS</span>
                                    <h2 className="title">
                                        Common Questions
                                        <span className="sm-title">
                                            About Our <span>Services</span>
                                        </span>
                                    </h2>
                                </div>
                                {/* faq accordion area */}
                                <div className="faq-accordion-area">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header><span>01. </span> What services does Aviteus Business Solutions provide?</Accordion.Header>
                                            <Accordion.Body>
                                                We offer comprehensive accounting, bookkeeping, tax planning, VAT returns, payroll management,
                                                business advisory, and financial management services. We also provide specialized services including
                                                Virtual CFO, audit support, and industry-specific accounting solutions for healthcare, construction,
                                                e-commerce, and other sectors.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header><span>02. </span> Do you support Making Tax Digital (MTD) compliance?</Accordion.Header>
                                            <Accordion.Body>
                                                Yes, we are fully equipped to help businesses with Making Tax Digital compliance. We use
                                                cloud-based accounting software like Xero, QuickBooks, and Sage to ensure your business meets
                                                HMRC's digital tax requirements for VAT and other tax submissions.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header><span>03. </span> How quickly do you respond to queries?</Accordion.Header>
                                            <Accordion.Body>
                                                We pride ourselves on responsive service. Each client is assigned a dedicated account manager
                                                who provides personal attention and quick responses. We aim to respond to all queries within
                                                24 hours during business days, and urgent matters are prioritized.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="3">
                                            <Accordion.Header><span>04. </span> What makes Aviteus different from other accountants?</Accordion.Header>
                                            <Accordion.Body>
                                                We combine qualified expertise (ICAEW/ACCA/CIMA accredited) with modern cloud-based technology
                                                and transparent pricing. Our team offers proactive advice, not just compliance services. We focus
                                                on building long-term partnerships and understanding your business goals to provide tailored solutions.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="4">
                                            <Accordion.Header><span>05. </span> Can you help with business startup and growth?</Accordion.Header>
                                            <Accordion.Body>
                                                Absolutely! We support businesses at every stage, from company formation and initial setup to
                                                growth planning and expansion. Our services include business valuation, fundraising support,
                                                cash flow management, and strategic financial planning to help your business thrive.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                                {/* faq accordion area end */}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="thumbnail-faq-four">
                                <img src="assets/images/faq/02.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* rts faq section area End */}


            {/* customers feed back area - Hidden for now */}
            {/* <div className="rts-customer-feedback-area rts-section-gap bg-customer-feedback" style={{display: 'none'}}>
            </div> */}
            {/* customers feed back area end */}


            <FooterOne />

        </div>
    )
}

export default OurService